import script from "./SearchBarComponent.vue?vue&type=script&setup=true&lang=js"
export * from "./SearchBarComponent.vue?vue&type=script&setup=true&lang=js"

import "./SearchBarComponent.vue?vue&type=style&index=0&id=3c6868b1&scoped=true&lang=scss"

import exportComponent from "D:\\liu\\jmzc\\jimuERPVUE\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-3c6868b1"]])

export default __exports__